import DealCredits from '../DealCredits';

const DealCreateBanks = ({deal, onSubmit, backHandler, services, documents, orders, update}) => {
  return (
    <>
      <DealCredits dealId={deal?.id} deal={deal} onSubmit={onSubmit} backHandler={backHandler} services={services} documents={documents} orders={orders} update={update}/>
    </>
  );
};

export default DealCreateBanks;
